// // src/Router.jsx
// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import Home from "../HomePage/index.jsx";
// import About from "../Aboutus";
// import Services from "../IndustriesWeServe";
// import Contact from "../ContactPage";
// import WhyChooseUs from "../WhyChooseUsPage";
// import Portfolio from "../OurPortfolioPage";
// import ServicesPage from "../Services/index.jsx";

// const AppRouter = () => {
//   return (
//     <Routes>
//       <Route path="/" element={<Home />} />
//       <Route path="/services" element={<Services />} />
//       <Route path="/about" element={<About />} />
//       <Route path="/contact" element={<Contact />} />
//       <Route path="/why-starlinklab" element={<WhyChooseUs />} />
//       <Route path="/portfolio" element={<Portfolio />} />
//       <Route path="/servicesPage" element={<ServicesPage />} />
//     </Routes>
//   );
// };

// export default AppRouter;



import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../HomePage/index.jsx";
import ContactPage from "../ContactPage";
import ContactForm from '../forms/contactForm.jsx';
import BookConsulatingForm from "../BookConsulationPage/BookConsulationPage.module.css";
import AboutUS from "../Aboutus/index.jsx";
import Ourservices from "../TechnologiesWeOffer/Services/index.jsx"

const AppRouter = () => (
  <Routes>
    <Route path="/" element={<Home />} />
     {/* <Route path="/" element={<HomePage />} /> */}
    <Route path="/contactform" element={<ContactForm />} />
    <Route path="/contact" element={<ContactPage />} />
    <Route path="/book-a-consulation" element={<BookConsulatingForm />} />
    <Route path="/aboutus" element={<AboutUS/>}/>
    <Route path="/ourservices" element={<Ourservices/>} />
  </Routes>
);

export default AppRouter;

